import { render, staticRenderFns } from "./hotSearch.vue?vue&type=template&id=0a156e30&scoped=true"
import script from "./hotSearch.vue?vue&type=script&lang=js"
export * from "./hotSearch.vue?vue&type=script&lang=js"
import style0 from "./hotSearch.vue?vue&type=style&index=0&id=0a156e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a156e30",
  null
  
)

export default component.exports